module.exports = __webpack_public_path__ + "static/media/craveably-creamy-dt-fr.eed4e703.jpg";